import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const accessibilityItems = [
  "Designed for hearing-impaired users and inclusive communication workflows.",
  "Real-time gesture recognition with clear visual feedback.",
  "Simple camera interaction that avoids cluttered controls.",
  "Responsive layout that stays usable on mobile screens.",
]

export default function Accessibility(){

return(

<div className="app-shell">

<Navbar/>

<section className="page-section">
<div className="section-shell px-6">
<div className="content-card page-copy rounded-[2rem] p-8 md:p-12">

<div className="eyebrow">Accessibility</div>

<h1 className="mt-6 text-4xl font-bold text-stone-900 md:text-5xl">

Accessibility

</h1>

<ul className="mt-8 space-y-4 text-lg">
{accessibilityItems.map((item) => (
<li key={item}>{item}</li>
))}
</ul>

</div>
</div>
</section>

<Footer/>

</div>

)

}
